module.exports = {"OCCURRENCE_BY_SOURCEID":"monitoring.monitoringOccurrenceEdition","TRIP_BY_SOURCEID":"monitoring.monitorableEdition"}